import React, { useState } from "react";
import { View, FlatList } from "react-native";
import { useDispatch } from "react-redux";
import { itemOptionsStyles as styles } from "./styles";
import { ModifyOptionsAsyncAction, OptionChoice } from "@/app/types/option";
import { Locale } from "@/app/types/translations";
import { formatMoney } from "@/app/utils/currency";
import { useTranslateText } from "@/app/utils";
import { modifyOptionsAsync } from "@/app/actions/options";
import { Dispatch } from "redux";
import { ChoiceHeader, RadioButton } from "../../RadioButton";

type ItemChoicesProps = {
  lineItemId: number;
  optionId: number;
  optionTitle: string;
  choices: OptionChoice[];
};

const renderSeparator = (): JSX.Element => (
  <View style={styles.listSeparator} />
);

const renderChoices = ({
  item,
  onChoicePress,
  locale,
}: {
  item: OptionChoice;
  onChoicePress: (choiceId: number) => void;
  locale: Locale;
}) => {
  const nameWithPrice =
    item.price !== 0
      ? `${item.name}  (+${formatMoney(item.price, true, locale)})`
      : `${item.name}`;
  return (
    <RadioButton
      onChoicePress={() => onChoicePress(item.id)}
      text={nameWithPrice}
      enabled={item.selected || (item.default && item.selected === undefined)}
    />
  );
};

const ItemChoices = ({
  lineItemId,
  optionId,
  choices,
  optionTitle,
}: ItemChoicesProps): JSX.Element => {
  const dispatch = useDispatch<Dispatch<ModifyOptionsAsyncAction>>();
  const { locale } = useTranslateText();
  const [showChoices, setShowchoices] = useState(true);
  const onChoicePress = (choiceId: number) => {
    dispatch(modifyOptionsAsync({ lineId: lineItemId, optionId, choiceId }));
    setShowchoices(true);
  };
  const selectedChoice = choices.find(
    (item) => item.selected || (item.default && item.selected === undefined),
  );
  return showChoices ? (
    <ChoiceHeader
      onHeaderPress={() => setShowchoices(!showChoices)}
      isOpen
      header={selectedChoice?.name}
    />
  ) : (
    <FlatList
      keyExtractor={({ id }) => `${id}`}
      ListHeaderComponent={
        <ChoiceHeader
          onHeaderPress={() => setShowchoices(!showChoices)}
          header={optionTitle}
        />
      }
      ItemSeparatorComponent={() => renderSeparator()}
      contentContainerStyle={styles.choiceContainer}
      data={choices}
      renderItem={({ item }) => renderChoices({ item, onChoicePress, locale })}
    />
  );
};

export default ItemChoices;
